// extracted by mini-css-extract-plugin
export default {"notFound":"fcb1a610338c"};